import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

interface ApiResponse<T> { success: boolean; message: string; data: T; }

export type AudienceType = 'CUSTOMER_GROUP' | 'CUSTOMERS' | 'CUSTOMER_STATUS' | 'ALL_CUSTOMERS';

export interface SendCampaignPayload {
  audience: {
    type: AudienceType;
    groupId?: number;
    customerIds?: number[];
    statuses?: string[];
  };
  templateId?: number;
  title?: string;
  body?: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationCampaignsService {
  private base = `${environment.url}/customer-notifications`;
  private http = inject(HttpClient);

  sendCampaign(payload: SendCampaignPayload): Observable<ApiResponse<{ id: number }>> {
    return this.http.post<ApiResponse<{ id: number }>>(`${this.base}/campaigns`, payload);
  }

  getCampaigns(): Observable<ApiResponse<unknown[]>> {
    return this.http.get<ApiResponse<unknown[]>>(`${this.base}/campaigns`);
  }

  getCampaign(id: number): Observable<ApiResponse<unknown>> {
    return this.http.get<ApiResponse<unknown>>(`${this.base}/campaigns/${id}`);
  }

  previewAudience(payload: { type: AudienceType; groupId?: number; customerIds?: number[]; statuses?: string[] }): Observable<ApiResponse<{ totalCustomers: number; pushReadyCount: number }>> {
    return this.http.post<ApiResponse<{ totalCustomers: number; pushReadyCount: number }>>(`${this.base}/audience/preview`, payload);
  }
}
